import React, { Component } from 'react';
import { Row, Col } from 'antd';
import CustomerBookingFormStepper from '../../components/forms/customerBooking/CustomerBookingFormStepper';
import FormStepService from '../../components/forms/customerBooking/FormStepService';
import FormStepDateTime from '../../components/forms/customerBooking/FormStepDateTime';
import FormStepPropertyDetails from '../../components/forms/customerBooking/FormStepPropertyDetails';
import FormStepCustomer from '../../components/forms/customerBooking/FormStepCustomer';
import FormStepAddons from '../../components/forms/customerBooking/FormStepAddons';
import FormStepBilling from '../../components/forms/customerBooking/FormStepBilling';
import FormComplete from '../../components/forms/FormComplete';
import LoadingSpinner from '../../components/LoadingSpinner';
import { withFormHandler } from '../providers/CustomerBookingFormHandler';


class CustomerBookingForm extends Component {
    renderActiveStep = () => {
        const { 
            activeStep, 
            submitForm,
            submitStep,
            isLoading,
            formValues,
        } = this.props;

        const stepProps = {
            submitStep,
        };

        switch (activeStep) {
            case 0:
                return <FormStepService {...stepProps} />;
            case 1:
                return <FormStepDateTime isFormStep {...stepProps} />;
            case 2:
                return <FormStepPropertyDetails {...stepProps} />;
            case 3:
                return <FormStepCustomer {...stepProps} />;
            case 4:
                return <FormStepAddons {...stepProps} />;
            case 5:
                return (
                    <FormStepBilling 
                        submitForm={submitForm} 
                        isLoading={isLoading}
                        formValues={formValues}
                        {...stepProps}
                    />
                );
            default:
                return null;
        }
    }

    render() {
        const {
            activeStep,
            isComplete,
            hasError,
            isLoading,
        } = this.props;

        if (hasError || isComplete) {
            return <FormComplete hasError={hasError} />;
        }

        return (
            <Row>
                <Col md={0} lg={2} />
                <Col md={24} lg={20}>
                    <CustomerBookingFormStepper activeStep={activeStep} />
                    {
                        isLoading
                        ? <LoadingSpinner />
                        : this.renderActiveStep()
                    }
                </Col>
                <Col md={0} lg={2} />
            </Row>
        );
    }
}

export default withFormHandler(CustomerBookingForm);
